import type { ReactNode } from "react";

/**
 * BD-1: badge statusu - pigulka z tintem, obrysem i tekstem statusu, 12px waga 600,
 * pisownia zdaniowa (TY-2).
 * BD-2: badge neutralny - --surface-sunken + --border + --text-muted. Kolory marki
 * w badge NIGDY (ST-1).
 * ST-3 / A-7: kolor nie niesie znaczenia sam - badge zawsze zawiera tekst.
 *
 * "zloto" i "szarosc" sa WYLACZNIE do oceny rozmowy wg metodyki (decyzja autora metodyki z 29.10.2026): zloto przy
 * tym, co najlepsze (mocna strona, najlepsza wypowiedz), szarosc przy tym, co do wymiany (do poprawy, najslabsza).
 * Wyglad jak BD-1 (tint, obrys 1px, tekst 12px 600, kropka), ale na tokenach --ocena-* (styles/ocena.css). Prawdziwe
 * statusy (zapisano, blad, usun, wgrano) zostaja na success, danger, warning i info.
 */

export type WariantBadge = "success" | "danger" | "warning" | "info" | "neutralny" | "zloto" | "szarosc";

export function Badge({
  wariant = "neutralny",
  kropka = false,
  children,
}: {
  wariant?: WariantBadge;
  /** BD-1: opcjonalna kropka 6px w kolorze statusu (albo oceny) przed tekstem. */
  kropka?: boolean;
  children: ReactNode;
}): React.JSX.Element {
  const neutralny = wariant === "neutralny";
  return (
    <span className={`badge${neutralny ? " badge--neutral" : ""}`} data-variant={neutralny ? undefined : wariant}>
      {kropka && !neutralny && <span className="badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

/**
 * BD-3: kropka "na zywo". 8px w --status-success z pulsem ~2 s; przy ograniczonym
 * ruchu (A-6) puls znika, kropka zostaje. ZAWSZE z etykieta tekstowa obok.
 *
 * ROZJAZD gotowcow: pipeline.html rysuje `.live__dot` jako 10px w --primary, a
 * badges-stats.html jako 8px w --status-success. Regula BD-3 nazywa 8px i success
 * wprost, wiec to ona rzadzi - jeden ksztalt kropki w calej aplikacji (C-1).
 */
export function KropkaNaZywo({
  children,
  statyczna = false,
}: {
  children: ReactNode;
  /** Wylacza puls tam, gdzie ruch bylby halasem (np. lista wielu wierszy). */
  statyczna?: boolean;
}): React.JSX.Element {
  return (
    <span className={`live${statyczna ? " live--static" : ""}`}>
      <span className="live__dot" aria-hidden="true" />
      {children}
    </span>
  );
}
